import {
    StepVariables,
    ToolContext
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

type StepTypes =
    | "startCheckout"
    | "startCustomer"
    | "submitCheckout"
    | "submitCustomer";

type LoginStepPlacement = "bestellen:login" | "klantgegevens:login";

const StepTypeMap: Record<StepTypes, LoginStepPlacement> = {
    startCheckout: "bestellen:login",
    startCustomer: "klantgegevens:login",
    submitCheckout: "bestellen:login",
    submitCustomer: "klantgegevens:login"
};

const TOOL_LOGIN_STEPS: Record<StepTypes, StepVariables> = {
    startCheckout: {
        stepName: "Bestaande klanten",
        stepNumber: 1,
        placement: StepTypeMap.startCheckout,
        result: {},
        option: ""
    },
    startCustomer: {
        stepName: "Bestaande klanten",
        stepNumber: 1,
        placement: StepTypeMap.startCustomer,
        result: {},
        option: ""
    },
    submitCheckout: {
        stepName: "succesvol ingelogd",
        stepNumber: 2,
        placement: StepTypeMap.submitCheckout,
        result: {},
        option: ""
    },
    submitCustomer: {
        stepName: "succesvol ingelogd",
        stepNumber: 2,
        placement: StepTypeMap.submitCustomer,
        result: {},
        option: ""
    }
};

const TOOL_LOGIN_CONTEXT: Readonly<ToolContext> = {
    name: "login",
    type: "form"
};

export { TOOL_LOGIN_CONTEXT, TOOL_LOGIN_STEPS };
